import React, { Component } from 'react'
import { Icon, List, WingBlank, WhiteSpace, Button, InputItem, Pagination, Toast, NavBar, Modal } from 'antd-mobile'
import axios from "../../../service/axios";
import NoneDatas from "../../../components/noneDatas";
const prompt = Modal.prompt;

export class BindingImei extends Component {
  state = {
    pageTotalNum: 0,
    pageNo: 1,
    userList: [],
    imeiList: [],
  };

  componentWillMount() {
    this.getUserList(1);
  }

  onPageChange(e) {
    const { pageTotalNum } = this.state;
    e = e > pageTotalNum ? pageTotalNum : e;
    this.getUserList(e);
    this.setState({
      selectNum: 0,
      selectGids: [],
    });
  }

  getUserList(e) {
    axios.get("api/user/ptt/unbound_imei/list", {
      params: {
        pageNo: e,
        pageSize: 10,
      },
    }).then((res) => {
      if (res && res.status == 200 && res.data) {
        if (res.data.resultList) {
          this.setState({
            userList: res.data.resultList,
            pageNo: res.data.pageNo,
            pageTotalNum: Math.ceil(res.data.totalCount / 10),
          });
        } else {
          this.setState({
            userList: [],
            pageNo: res.data.pageNo,
            pageTotalNum: Math.ceil(res.data.totalCount / 10),
          });
        }
      }
    }).catch((error) => {
      console.log(error);
    });
  }

  onChange = (imei, e) => {
    const imeiList = [...this.state.imeiList];
    if (imeiList.map(item => item.uid).includes(e.uid)) {
      imeiList.splice(imeiList.findIndex(item => item.uid == e.uid), 1);
    }
    if (imei) {
      imeiList.push({ uid: e.uid, account: e.account, password: e.password, imei });
    }
    this.setState({
      imeiList,
    });
  }

  onSave() {
    const { imeiList } = this.state;
    if (imeiList.length > 0) {
      const illegalImeiList = imeiList.filter(item => !/^[A-Za-z0-9]{12,16}$/.test(item.imei));
      console.log(illegalImeiList)
      if (illegalImeiList.length > 0) {
        Toast.fail(`账号${illegalImeiList[0].account}的IMEI号输入有误`);
        return;
      }
      prompt(
        '经销商密码',
        '',
        password => {
          if (!password) {
            Toast.fail(`请输入经销商密码`);
            return;
          };
          const newImeiList = imeiList.map(item => { return { ...item, agentpwd: password } })
          console.log(newImeiList)
          axios.post("/api/user/ptt/binding_imei", newImeiList).then(res => {
            if (res && res.status == 200) {
              Toast.success(res.message, 2, () => {
                window.location.reload();
              });
            } else {
              Toast.fail(res.message);
            }
          });
        },
        'default',
        '123456',
      )
    }
  }

  render() {
    const { pageTotalNum, pageNo, userList, } = this.state
    return (
      <div className="container">
        <div className="header-sticky">
          <NavBar
            icon={<Icon type="left" />}
            onLeftClick={() => window.history.go(-1)}
          >
            批量绑定IMEI号
          </NavBar>
        </div>
        <div className="sub-container">
          <List>
            {userList.map((item, index) => (
              <div key={index}>
                <InputItem value={item.account} disabled>账号{index + 1}：</InputItem>
                <InputItem placeholder="请输入12~16位数字和字母" maxLength={16} onChange={e => this.onChange(e, item)}>IMEI</InputItem>
              </div>
            ))}
            <WingBlank>
              {pageTotalNum > 0 ? (
                <Pagination
                  total={pageTotalNum}
                  current={pageNo}
                  locale={{
                    prevText: "上一页",
                    nextText: "下一页",
                  }}
                  onChange={e => this.onPageChange(e)}
                />
              ) : (
                  ""
                )}
            </WingBlank>
            {userList.length == 0 ? <NoneDatas /> : ""}
            <WingBlank>
              <WhiteSpace size="xl" />
              <Button type="primary" onClick={() => this.onSave()}>
                确定
            </Button>
              <WhiteSpace size="xl" />
              <Button type="" onClick={() => window.history.go(-1)}>
                返回
            </Button>
              <WhiteSpace size="xl" />
            </WingBlank>
          </List>
        </div>
      </div >
    )
  }
}

export default BindingImei;
